import React from 'react';
import { Database, Scale } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/store';
import { caseSelectOneObjectByQuery } from '../../redux/thunks/DBServiceThunks';
import PanelHeader from '../common/PanelHeader';

interface KnowledgebaseHeaderProps {
  activeTab: 'documents' | 'timeline' | 'history';
}

export default function KnowledgebaseHeader({
  activeTab
}: KnowledgebaseHeaderProps) {
  const { t } = useTranslation();

  const currentCaseId = useAppSelector(state => state.CaseReducer.currentCaseId);
  const currentCase = useAppSelector(state =>
    caseSelectOneObjectByQuery(state.DBCaseReducer, { _id: currentCaseId })
  );

  const description = activeTab === 'documents'
    ? t('common.knowledgebase.accessManageDocuments')
    : t('common.timeline.overview');

  return (
    <PanelHeader
      icon={<Database size={20} strokeWidth={1.5} className="text-gold" />}
      title={t('common.knowledgebase.knowledgeBase')}
      tooltipText={description}
      subtitle={currentCase ? (
        <>
          <Scale size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">
            {currentCase.title}
          </span>
        </>
      ) : undefined}
    />
  );
} 
